module.exports = __webpack_public_path__ + "static/androidTV+TV-44f242c36ad8c57f6644ffb9e88d3460.png";